
import { ILopTinChiViewModel } from "../../../model/respone/lop-tin-chi/ILopTinChiViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eQuanLyDangKyActionsObj = {
    CHANGE_SELECTED_TAB: "" as "mo-dot" | "pham-vi" | "kiem-tra" | "nap-du-lieu" | "xem-du-lieu" | "dashboard" | "dong-bo" | "ket-thuc",
    LOAD_LOP_TIN_CHI_START: {} as { kyDangKys: number[]},
    LOAD_LOP_TIN_CHI_SUCCESS: {} as ILopTinChiViewModel[],
    LOAD_LOP_TIN_CHI_ERROR: "",

    CHANGE_SELECTED_QUY_DINH_ID: {} as number,
    
};

export const eQuanLyDangKyActionIds = generateActionTypeIds(eQuanLyDangKyActionsObj, "QUAN_LY_DANG_KY");
export type IQuanLyDangKyActionTypes = IGenericActionType<typeof eQuanLyDangKyActionsObj, "QUAN_LY_DANG_KY">;